import React from 'react';

import { Tag } from '@tecma/ds';
import { useTranslation } from '@tecma/i18n';
import classNames from 'classnames';

import './apartment-status-tag.scss';

interface ApartmentStatusTagRequiredProps {
  label: string;
}

// Optional Props
interface ApartmentStatusTagOptionalProps {
  className?: string;
  color?: 'primary' | 'error' | 'info' | 'success' | 'warning';
  statusReason?: string;
}

// Combined required and optional props to build the full prop interface
export interface ApartmentStatusTagProps extends ApartmentStatusTagRequiredProps, ApartmentStatusTagOptionalProps {}

const ApartmentStatusTag: React.FC<ApartmentStatusTagProps> = ({ label, className, color = 'primary', statusReason }) => {
  const { t } = useTranslation();
  const apartmentStatusTagClassList = classNames('apartment-status-tag', {
    [`${className}`]: className,
    [`${color}`]: color,
  });
  const tag = <Tag className={apartmentStatusTagClassList} label={t(`status.${label}`, { defaultValue: label })} />;

  if (!statusReason) {
    return tag;
  }

  const statusReasonClassList = classNames('apartment-status-tag__reason', {
    [`${color}`]: color,
  });

  return (
    <div className='apartment-status-tag__wrapper'>
      {tag}
      <span className={statusReasonClassList}>{t(`statusReason.${statusReason}`, { defaultValue: statusReason })}</span>
    </div>
  );
};

export default React.memo(ApartmentStatusTag);
